import React from 'react'
import { l } from '@manychat/manyui'

import { typedRouting } from 'utils/router'

export const WABrokenMessageTemplateIsInUse = () => {
  const logsUrl = typedRouting.linkBuilder.settings({ hash: 'logs' })
  return (
    <span>
      {l.translate(
        'There is an issue with Message Templates in your Automations. <a class="text-primary" href="{url}" target="_blank" rel="noreferrer">Learn more in Logs</a>.',
        {
          url: logsUrl,
        },
      )}
    </span>
  )
}
